"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessTypeToJSON = exports.BusinessTypeFromJSONTyped = exports.BusinessTypeFromJSON = exports.BusinessType = void 0;
/**
 * The type of the business.
 * @export
 */
exports.BusinessType = {
    Advertiser: 'ADVERTISER',
    Agency: 'AGENCY',
    Internal: 'INTERNAL',
    MusicArtistConcertPromoter: 'MUSIC_ARTIST_CONCERT_PROMOTER',
    PodcastPromoter: 'PODCAST_PROMOTER',
    UnsetBusinessType: 'UNSET_BUSINESS_TYPE',
    Unrecognized: 'UNRECOGNIZED'
};
function BusinessTypeFromJSON(json) {
    return BusinessTypeFromJSONTyped(json, false);
}
exports.BusinessTypeFromJSON = BusinessTypeFromJSON;
function BusinessTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.BusinessTypeFromJSONTyped = BusinessTypeFromJSONTyped;
function BusinessTypeToJSON(value) {
    return value;
}
exports.BusinessTypeToJSON = BusinessTypeToJSON;
